import React, { useState } from 'react';

import { useChatInteract } from '@chainlit/react-client';

import { Translator } from '@/components/i18n';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components/ui/tooltip';

import { EditSquare } from '../icons/EditSquare';

type NewChatDialogProps = {
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
};

export const NewChatDialog = ({
  open,
  handleClose,
  handleConfirm
}: NewChatDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent id="new-chat-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            <Translator path="navigation.newChat.dialog.title" />
          </DialogTitle>
          <DialogDescription>
            <Translator path="navigation.newChat.dialog.description" />
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={handleClose}>
            <Translator path="common.actions.cancel" />
          </Button>
          <Button variant="default" onClick={handleConfirm} id="confirm">
            <Translator path="common.actions.confirm" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  navigate?: (to: string) => void;
}

const NewChatButton = ({ navigate, ...buttonProps }: Props) => {
  const [open, setOpen] = useState(false);
  const { clear } = useChatInteract();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    clear();
    navigate?.('/askawatch');
    handleClose();
  };

  return (
    <div>
      <TooltipProvider>
        {/* <Tooltip> */}
          {/* <TooltipTrigger asChild> */}
          <Button
            variant="ghost"
            size="sm"
            id="new-chat-button"
            className="group relative bg-gradient-to-r from-white/10 to-white/5 backdrop-blur-md text-white/90 hover:text-[#C9D1D3] hover:from-white/20 hover:to-white/10 border border-white/20 hover:border-white/40 transition-all duration-300 rounded-xl px-3 py-1.5 gap-1.5 font-medium shadow-lg hover:shadow-xl hover:scale-105"
            onClick={handleClickOpen}
            {...buttonProps}
          >
            <EditSquare className="size-3.5 transition-transform duration-300 group-hover:scale-110" />
            <span className="text-xs font-medium hidden sm:inline">New Chat</span>
          </Button>
          {/* </TooltipTrigger> */}
          {/* <TooltipContent> */}
            {/* <Translator path="navigation.newChat.dialog.tooltip" /> */}
          {/* </TooltipContent> */}
        {/* </Tooltip> */}
      </TooltipProvider>
      <NewChatDialog
        open={open}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
      />
    </div>
  );
};

export default NewChatButton;
